// extracted by css-extract-rspack-plugin
export default {"cls1":"LoswpPickDownloadHero-cls1_l8b","cls2":"LoswpPickDownloadHero-cls2_kEF LoswpPickDownloadHero-cls1_l8b"};